module.exports = __webpack_public_path__ + "img/Icon-Surgeries.42744d54.svg";